export const APP_FILE_BEFORE_PROFILE = "/users";
export const APP_FILE_MANAGE_USER = "/users/manage";
export const APP_FILE_MY_PROFILE_VIEW= "/my-profile";
export const APP_FILE_CONTINUING_EDUCATION = "/users/continuing-education";
export const APP_FILE_USER_LICENSE = "/users/user-license";